import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux"
import { getBranchById, getUserPreference} from '../../../../utilities/common';
import { editZoneSlotMapping, getZoneSlotMapping, createZoneSlotMapping, deleteZoneSlot } from '../../../../actions/saActions';
import { Button, Paper, TextField } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddIcon from '@material-ui/icons/Add';
import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import DialogContentText from '@material-ui/core/DialogContentText';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../../reducers/uiSlice';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import UniDialog from '../../../../components/Common/UniDialog';
import FullscreenLoading from '../../../../components/Common/FullscreenLoading';

const useStyles = makeStyles((theme)=> ({
    zoneDetails: {
        marginTop: 5,
        border: '1px solid rgba(255, 255, 255, 0.5)',
        width: 310,
        borderRadius: 5,
        padding: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    addButton: { 
        marginLeft: 'auto', 
        marginRight: 'auto', 
        padding: 10,
        textAlign: 'center'
    },
    tableRowColor: { 
        background: '#212121' 
    },
    tableCellFormat: { 
        fontSize: '1.2rem', 
        textAlign: 'center' 
    },
    gridStyle: {
        marginRight: 10
    }
}))

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '5px !important',
        },
        '& .MuiInputBase-root': {
            width: 40
        }
    },
}))(TextField);

const FixedTextFieldZone = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '5px !important',
        },
        margin: 10
    },
}))(TextField);

function SortingZone(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('slotAssignment');
    
    let userPref = getUserPreference();

    const branches = useSelector(state => state.common.branches);
    const maxSlot = useSelector(state=>state.saReducer.getWarehouseTotalSlots);

    const [open, setOpen] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [branch, setBranch] = useState('');
    const [branchNum, setBranchNum] = useState(userPref.userCity)
    const [zoneSlot, setZoneSlot] = useState([]);
    const [createZone, setCreateZone] = useState('');
    const [openAssign, setOpenAssign] = useState(false);
    const [createZoneSlot, setCreateZoneSlot] = useState([]);
    const gridCodesNum = 12;
    const gridCodesEmpty = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const [editZoneSlot, setEditZoneSlot] = useState([]);
    const [openView, setOpenView] = useState(false);
    const [responseError, setResponseError] = useState('');
    const [change, setChange] = useState(false);
    const [loading, setLoading] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [pair, setPair] = useState({});
    
    const timer = useRef();

    const handleClickOpenAdd = () => {
        setOpenAssign(true);
    };
    const handleCreate = () => {
        let createGridCode = '';
        for(var i in createZoneSlot) {
            createGridCode = createGridCode.concat(',' + createZoneSlot[i].grid);
        }
        createGridCode = createGridCode.substring(1);               
        if(createZone && createGridCode) {
            setLoading(true);
            if(checkGridCodesFormat(createGridCode)) {
                setLoading(true);
                dispatch(createZoneSlotMapping(branchNum, createZone, createGridCode))
                .then((res) => {
                    dispatch(showAlertSnackbar({message: t('create_success'), type: 'success'}))
                    dispatch(getZoneSlotMapping(branchNum))
                    .then(() => {
                        setOpenAdd(false);
                        dispatch(showAlertSnackbar({message: t('update_success'), type: 'success'}))
                    })
                    .finally(() => {
                        setLoading(false);
                    })
                })
                .catch((error) => {
                    setResponseError(error.message);
                    dispatch(showAlertSnackbar({message: error.message, type: 'error'}))
                    setLoading(false);
                })
                .finally(() => {
                    setLoading(false);
                })
                .finally(() => {
                    setLoading(false);
                })
            } else {
                dispatch(showAlertSnackbar({message: t('input_number'), type: 'error'}))
            }
        } else {
            dispatch(showAlertSnackbar({message: t('complete_info'), type: 'error'}))
        }        
    }
    const handleCloseAdd = () => {
        setOpenAdd(false);
    };
    const handleClickOpen = () => () => {
        dispatch(getZoneSlotMapping(branchNum))
        .then(() => {
            setOpen(true);
        })        
    };
    const handleClose = () => {
        setOpen(false);
    };
    const addChangeGridCodes = (grid, zone, id, index) => {
        setChange(true);
        let editZoneSlotCurr = editZoneSlot;
        let exist = false;
        for (var i in editZoneSlotCurr) {
            if (editZoneSlotCurr[i].id === id && editZoneSlotCurr[i].index + '' === index + '') {
                exist = true;
                editZoneSlotCurr[i].grid = grid;
                break;
            }
        }
        if(!exist) {
            editZoneSlotCurr.push({
                zone: zone,
                grid: grid,
                id: id,
                index: index
            })
        }
        setEditZoneSlot(editZoneSlotCurr);
    }
    const handleCreateZone = (event) => {
        setCreateZone(event.target.value)
    }
    const handleCreateInput = (grid, index) => {
        let createZoneSlotCurr = createZoneSlot;
        let exist = false;
        for(var i in createZoneSlotCurr) {
            if(createZoneSlotCurr[i].index === index) {
                exist = true;
                createZoneSlotCurr[i].grid = grid;
                break;
            }
        }
        if(!exist) {
            createZoneSlotCurr.push({
                grid: grid,
                index: index
            })
        }
        setCreateZoneSlot(createZoneSlotCurr)
    }
    const handleCloseAssign = () => {       
        setOpenAssign(false);
    };
    const handleViewOpen = () => {
        setOpenView(true);
    }
    const handleCloseView = () => {
        setOpenView(false);
    }

    const handleDelete = () => {
        setLoading(true);
        dispatch(deleteZoneSlot({mapping_ids: pair.id}))
        .then(() => {
            dispatch(showAlertSnackbar({message:t('update_success'), type: 'success'}))
            dispatch(getZoneSlotMapping(branchNum))
            .finally(() => {
                setLoading(false);
            })
        })
        .catch((err) => {
            setLoading(false);
            dispatch(showAlertSnackbar({message:err.message, type: 'error'}))
        })
        .finally(() => {
            setDeleteOpen(false);
        })
    }

    const handleDeleteOpen = (isOpen, pair) => {
        setPair(pair);
        setDeleteOpen(isOpen);
    }

    useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    useEffect(() => {
        let zoneSlot = [];
        for(var i in props.zoneSlot) {
            const gridCodes = props.zoneSlot[i].grid_codes.split(',')
            for(var j in gridCodes) {
                zoneSlot.push({
                    zone: props.zoneSlot[i].sorting_zone,
                    grid: gridCodes[j],
                    id: props.zoneSlot[i].id,
                    index: j
                })
            }                
        }
        setEditZoneSlot(zoneSlot);
    }, [props.zoneSlot])

    const descriptionElementRef = useRef(null);
    useEffect(() => {
        if (open) {
        const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    useEffect(() => {
        setBranchNum(props.branch);        
    }, [props.branch])

    useEffect(() => {
        let branchCurr = getBranchById(props.branch);
        if(branchCurr) {
            setBranch(branchCurr.name);            
        }
    }, [branches, props.branch])

    useEffect(() => {
        if(props.zoneSlot.length > 0) {
            setZoneSlot(props.zoneSlot);
        }
    }, [props.zoneSlot])

    return (
        <Paper color="text.primary">
            <div>{t('sorting_zone_edit')}</div>
            <div className={classes.zoneDetails}>
                <div>{t('zone')} &#38; {t('grid_code')}</div>
                <div>
                    <Button
                        style={{ marginRight: 5}}
                        variant="contained" 
                        color="primary" 
                        onClick={handleViewOpen}
                    >
                        {t('view')}
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={handleClickOpen()}
                    >
                        {t('edit')}
                    </Button>
                </div>
                
            </div>
            <Dialog
                open={openView}
                onClose={handleCloseView}
                style={{ padding: 30 }}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>{t('zone_slot_mapping')}</DialogTitle>
                <DialogContent>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow className={classes.tableRowColor}>
                                    <TableCell align="center" className={classes.tableCellFormat}>{t('warehouseNew')}</TableCell>
                                    <TableCell align="center" className={classes.tableCellFormat}>{t('sorting_zone')}</TableCell>
                                    <TableCell align="center" className={classes.tableCellFormat}>{t('grid_code')}</TableCell>
                                    <TableCell align="center" className={classes.tableCellFormat}>{t('remark')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {zoneSlot.map((row, index) => (
                                <TableRow
                                    key={row.id}
                                    style={ index % 2? { background : "#424242" }:{ background : "#303030" } }
                                >
                                    <TableCell align="center">{branch}</TableCell>
                                    <TableCell align="center">{row.sorting_zone}</TableCell>
                                    <TableCell align="center">{row.grid_codes}</TableCell>
                                    <TableCell align="center">{row.remark}</TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseView} color="primary">
                        {t('close')}
                    </Button>
                </DialogActions>
            </Dialog>
            
            <Dialog
                open={openAssign}
                onClose={handleCloseAssign}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t('assign_current_mapping')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseAssign} color="primary" disabled={loading}>
                    {t('cancel')}
                </Button>
                <Button onClick={handleOpenCreate} color="primary" autoFocus disabled={loading}>
                    {t('assign')}
                </Button>
                {loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
                </DialogActions>
            </Dialog>
            <Dialog
                open={openAdd}
                onClose={handleCloseAdd}
                maxWidth="md"
                fullWidth
            >
                <DialogContent dividers>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow className={classes.tableRowColor}>
                                    <TableCell align="center" className={classes.tableCellFormat}>{t('zone')}</TableCell>
                                    <TableCell align="center" className={classes.tableCellFormat}>{t('grid_code')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow style={{ background : "#303030" }}>
                                    <TableCell align="center">
                                        <FixedTextFieldZone
                                            onChange={handleCreateZone}
                                            size="small"
                                            variant="outlined"
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                    {
                                        gridCodesEmpty.map((gridCode, index) => {
                                            return (
                                                <FixedTextField
                                                    onChange={(e)=>{handleCreateInput(e.target.value, index)}}  
                                                    size="small" 
                                                    variant="outlined"
                                                    className={classes.gridStyle}
                                                />
                                            )
                                        }) 
                                    }
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseAdd} color="primary">
                    {t('cancel')}
                </Button>
                <Button onClick={handleCreate} color="primary">
                    {t('create_zone')}
                </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="scroll-dialog-title">{branch}</DialogTitle>
                <DialogContent dividers>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow className={classes.tableRowColor}>
                                    <TableCell align="center" className={classes.tableCellFormat}>{t('zone')}</TableCell>
                                    <TableCell align="center" className={classes.tableCellFormat}>{t('grid_code')}</TableCell>
                                    <TableCell align="center" className={classes.tableCellFormat}>{t('delete')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                    {   
                                        (zoneSlot.length > 0) && zoneSlot.map((pair, index) => {
                                            const gridCodes = pair.grid_codes;
                                            const gridCodesArray = gridCodes.split(',');
                                            const lengthRest = gridCodesNum - gridCodesArray.length;
                                            const gridCodesRest = [];
                                            for(let i = 0; i < lengthRest; i++) {
                                                gridCodesRest.push(0);
                                            }
                                            return (
                                                <TableRow style={ index % 2? { background : "#424242" }:{ background : "#303030" } } key={'pair-' + pair.id}>
                                                    <TableCell align="center">
                                                        {pair.sorting_zone}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {
                                                            gridCodesArray.map((gridCode, index) => {                                                           
                                                                return (
                                                                    <FixedTextField
                                                                        defaultValue={gridCode}
                                                                        onChange={(e) => addChangeGridCodes(e.target.value, pair.sorting_zone, pair.id, index)}
                                                                        size="small" 
                                                                        variant="outlined"
                                                                        className={classes.gridStyle} 
                                                                    /> 
                                                                );
                                                            })
                                                        }
                                                        {
                                                            gridCodesRest.map((gridCode, index) => {
                                                                return (
                                                                    <FixedTextField
                                                                        onChange={(e) => addChangeGridCodes(e.target.value, pair.sorting_zone, pair.id, index + gridCodesArray.length)}
                                                                        size="small" 
                                                                        variant="outlined"
                                                                        className={classes.gridStyle} 
                                                                    /> 
                                                                );
                                                            })
                                                        }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IndeterminateCheckBoxIcon 
                                                            id={`slotassignment-sortingzone-delete-${index}`}
                                                            color='secondary'
                                                            style={{cursor:'pointer'}}
                                                            onClick={()=>handleDeleteOpen(true, pair)}
                                                        />
                                                    </TableCell>                   
                                                </TableRow>
                                            );
                                        })
                                    }                                                 
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <ListItem autoFocus className={classes.addButton} button onClick={handleClickOpenAdd} align='center'>
                        <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                            <ListItemAvatar>
                                <Avatar>
                                    <AddIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <div>{t('create_zone_grid')}</div>
                        </div>                            
                    </ListItem>                          
                </DialogContent>
                <DialogActions>
                <Button 
                    onClick={handleClose} 
                    color="primary" 
                    id='slotassignment-sortingzone-close-button'
                >
                    {t('cancel')}
                </Button>
                <Button 
                    onClick={()=>handleAssign(false)} 
                    color="primary"
                    id='slotassignment-sortingzone-assign-button'
                >
                    {t('assign')}
                </Button>
                </DialogActions>
            </Dialog>
            <UniDialog
                fullWidth
                open={deleteOpen}
                onClose={()=>setDeleteOpen(false)}
                onFinish={handleDelete}
                autoClose={false}
            >
                {t('confirm_delete')}{pair?.sorting_zone}: {pair?.grid_codes}
            </UniDialog>            
            <FullscreenLoading open={loading}/> 
        </Paper>
    );

    function checkGridCodesFormat(gridCodes) {
        var gridCodesRegex = /^[-+]?(?:[0-9]+,)*[0-9]+(?:[0-9]+)?$/i;
        if(gridCodesRegex.test(gridCodes)) {            
            return true;
        } else {
            return false;
        }
    }

    function handleOpenCreate() {
        if(change) {
            if (!loading) {
                setLoading(true);
                timer.current = window.setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
            handleAssign(true);
        } else {
            setOpenAdd(true);
            setOpenAssign(false);
        } 
    }

    function transferZoneSlot() {
        let editZoneSlotPara = []; 
        let grids = [];  
        editZoneSlot.map((zoneGrid) => {
            let exist = false;
            for(var i in editZoneSlotPara) {
                if(zoneGrid.id === editZoneSlotPara[i].mapping_id) {
                    exist = true;
                    if(zoneGrid.grid) {
                        grids = grids.concat(zoneGrid.grid.split(','));
                        editZoneSlotPara[i].grid_codes = editZoneSlotPara[i].grid_codes.concat(',' + zoneGrid.grid); 
                    }       
                    break;
                }
            }
            if(!exist) {
                grids = grids.concat(zoneGrid.grid.split(','));
                editZoneSlotPara.push({
                    mapping_id: zoneGrid.id,
                    zone: zoneGrid.zone,
                    grid_codes: zoneGrid.grid
                })
            }
        })
        return {
            zoneSlots: editZoneSlotPara,
            grids: grids
        };
    }

    function handleAssign(isCreate = false) {
        const editZoneSlotPara = transferZoneSlot().zoneSlots;
        const grids = transferZoneSlot().grids;
        let wrong = false;
        if(grids?.length > 0) {
            const duplicates = grids.filter((item, index) => grids.indexOf(item) !== index);
            const maxSlots = grids.filter((item) => item > maxSlot);
            if(duplicates?.length > 0) {
                wrong = true;
                dispatch(showAlertSnackbar({message: t('duplicate_input'), type: 'error'}))
                return;
            }
            if(maxSlots?.length > 0) {
                wrong = true;
                dispatch(showAlertSnackbar({message: t('max_input') + maxSlot, type: 'error'}))
                return;
            }
        }
        if(editZoneSlotPara) {
            editZoneSlotPara.forEach((zoneGrid) => {
                if(!checkGridCodesFormat(zoneGrid.grid_codes) && zoneGrid.grid_codes) {
                    wrong = true;
                    dispatch(showAlertSnackbar({message: t('input_number'), type: 'error'}))
                    return;
                }
            })
        }
        if(!wrong) {
            zoneSlotMapping(branchNum, editZoneSlotPara, isCreate);
        } 
    }

    function zoneSlotMapping(branchNum, editZoneSlotPara, isCreate=false) {
        setLoading(true);
        dispatch(editZoneSlotMapping(branchNum, editZoneSlotPara))
        .then(() => {
            dispatch(showAlertSnackbar({message:t('update_success'),type:'success'}));                       
            if(isCreate) {
                setOpenAssign(false);
                setOpenAdd(true);
            } else {
                dispatch(getZoneSlotMapping(branchNum))
                .then(() => {
                    setChange(false);
                })
                .finally(() => {
                    setLoading(false);
                    setOpen(false);
                })
            }
        })
        .catch((error) => {
            setResponseError(error.message);
            dispatch(showAlertSnackbar({message: error.message, type: 'error'}))
        })
        .finally(() => {
            setLoading(false);
        })
    }
}

export default SortingZone;